import React, { useState } from 'react';
import {
  Box,
  Icon,
  Icons,
  Stack,
  Typography,
} from '@nextiva/next-ui-components';
import { CardCompanyTypeProps } from 'interface/WizardV3';
import {
  CardStyled,
  CardContentStyled,
  CheckIcon,
  RadioStyled,
} from './CardCompanyType.styled';

export const CardCompanyType = ({
  companyInfo,
  isSelected,
  dataTestId,
}: CardCompanyTypeProps) => {
  const { title, description, required, icon, value } = companyInfo;
  const [isHovered, setIsHovered] = useState(false);

  return (
    <CardStyled
      checked={isSelected}
      data-testid={`${dataTestId}-Card`}
      variant="elevation"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <CardContentStyled data-testid={`${dataTestId}-CardContent`}>
        <RadioStyled
          checkedIcon={<Icon icon={Icons.checkCircleSolid} color="primary" />}
          checked={isSelected}
          data-testid={`${dataTestId}-Card-Radio`}
          value={value}
        />
        {!isSelected && isHovered && <CheckIcon icon={Icons.checkCircle} />}
        <Stack spacing={1} alignItems="center" justifyContent="center">
          <Icon icon={icon} size={32} sx={{ color: '#ACAEB8' }} />
          <Typography
            data-testid={`${dataTestId}-Card-Title`}
            variant="body2"
            align="center"
            fontWeight={800}
            sx={{ color: '#0B1029' }}
          >
            {title}
          </Typography>
          <Box maxHeight="76px">
            <Typography
              data-testid={`${dataTestId}-Card-Description`}
              variant="caption"
              align="center"
              paragraph
              sx={{ marginBottom: '12px', color: '#55596B' }}
            >
              {description}
            </Typography>

            <Typography
              data-testid={`${dataTestId}-Card-Required`}
              variant="caption"
              align="left"
              color="text.secondary"
              paragraph
              sx={{ marginBottom: '0px', color: '#55596B' }}
            >
              <strong>Required:</strong> {required}
            </Typography>
          </Box>
        </Stack>
      </CardContentStyled>
    </CardStyled>
  );
};
